(() => {
  'use strict';
  const key='caravan-saved-records', tokenKey='caravan-wishlist-guest', ownerKey='caravan-wishlist-owner';
  const prefix='/apps/caravan-wishlist';
  const ja=document.documentElement.lang.startsWith('ja');
  const text={loading:ja?'Wishlistを読み込んでいます。':'Loading your wishlist.',browser:ja?'このブラウザに保存しています。オンライン保存は現在利用できません。':'Saved in this browser. Online saving is currently unavailable.',guest:ja?'このブラウザのWishlistを保存しました。ログインするとアカウントに引き継げます。':'Wishlist saved for this browser. Sign in to keep it in your account.',account:ja?'Wishlistをアカウントに保存しました。':'Wishlist saved to your account.',pending:ja?'このブラウザに保存しました。オンライン保存は保留中です。':'Saved in this browser. Online saving is pending.'};
  const read=(name,fallback)=>{try{return JSON.parse(localStorage.getItem(name)||'null')??fallback;}catch{return fallback;}};
  const ids=value=>Array.isArray(value)?[...new Set(value.map(String).filter(id=>/^[1-9][0-9]{0,19}$/.test(id)))].slice(0,500):[];
  let token=read(tokenKey,''), scope='', account=false, ready=false, publishing=false, running=false;
  let previous=ids(read(key,[])), pending={};
  const before=read(ownerKey,null), original=[...previous];
  const notes=()=>document.querySelectorAll('.record-wishlist-note');
  function note(value){notes().forEach(el=>{el.textContent=value;el.setAttribute('role','status');});}
  function savePending(){localStorage.setItem('caravan-wishlist-pending:'+scope,JSON.stringify(pending));}
  async function api(path,body){
    const controller=new AbortController(), timeout=setTimeout(()=>controller.abort(),15000);
    try{
      const headers={'Accept':'application/json'};if(token)headers['X-Wishlist-Guest']=token;
      if(body)headers['Content-Type']='application/json';
      const response=await fetch(prefix+path,{method:body?'POST':'GET',headers,body:body?JSON.stringify(body):undefined,credentials:'same-origin',cache:'no-store',signal:controller.signal});
      if(!response.ok)throw Error('Wishlist connection unavailable');
      return await response.json();
    }finally{clearTimeout(timeout);}
  }
  function publish(values){
    publishing=true;previous=ids(values);const serialized=JSON.stringify(previous);localStorage.setItem(key,serialized);
    window.dispatchEvent(new StorageEvent('storage',{key,newValue:serialized}));
    document.querySelectorAll('[data-save]').forEach(button=>{const saved=previous.includes(button.dataset.save);button.setAttribute('aria-pressed',String(saved));button.textContent=saved?'♥':'♡';});
    document.dispatchEvent(new Event('caravan-wishlist-change'));publishing=false;
  }
  async function flush(){
    if(!scope||running||!navigator.onLine)return;
    running=true;let failed=false;
    try{
      for(const [productId,saved] of Object.entries({...pending})){
        await api('/wishlist',{productId,saved});
        if(pending[productId]===saved){delete pending[productId];savePending();}
      }
      note(Object.keys(pending).length?text.pending:(account?text.account:text.guest));
    }catch{failed=true;note(text.pending);}finally{running=false;if(!failed&&Object.keys(pending).length)queueMicrotask(flush);}
  }
  document.addEventListener('click',event=>{
    if(!ready&&event.target.closest('button[data-save],button.dock-wish')){event.preventDefault();event.stopImmediatePropagation();note(text.loading);}
  },true);
  document.addEventListener('caravan-wishlist-change',()=>{
    if(publishing||!ready)return;
    const now=ids(read(key,[]));
    if(scope){for(const id of new Set([...previous,...now]))if(previous.includes(id)!==now.includes(id))pending[id]=now.includes(id);savePending();}
    previous=now;note(scope?text.pending:text.browser);flush();
  });
  window.addEventListener('online',flush);
  window.addEventListener('storage',event=>{if(event.key===key&&!publishing){previous=ids(read(key,[]));}if(scope&&event.key==='caravan-wishlist-pending:'+scope){pending=read(event.key,{});flush();}});
  note(text.loading);
  if(before?.account)publish([]);
  (async()=>{
    try{
      const session=await api('/session',{});
      if(!/^[a-f0-9]{64}$/.test(session.ownerKey)||typeof session.account!=='boolean')throw Error('Invalid session');
      account=session.account;scope=session.ownerKey;
      if(session.guestToken){token=session.guestToken;localStorage.setItem(tokenKey,JSON.stringify(token));}
      if(account&&token){await api('/wishlist',{action:'merge'});token='';localStorage.removeItem(tokenKey);}
      const remote=await api('/wishlist');if(!Array.isArray(remote.productIds))throw Error('Invalid wishlist');
      const queued=read('caravan-wishlist-pending:'+scope,{});
      pending=Object.fromEntries(Object.entries(queued).filter(([id,value])=>/^[1-9][0-9]{0,19}$/.test(id)&&typeof value==='boolean'));
      // Import the original browser list once, or carry unsent guest choices through sign-in.
      if(!before||(!before.account&&account))for(const id of original)pending[id]=true;
      if(before&&!before.account&&account&&before.scope){const guestPending=read('caravan-wishlist-pending:'+before.scope,{});for(const [id,value] of Object.entries(guestPending))if(/^[1-9][0-9]{0,19}$/.test(id)&&typeof value==='boolean')pending[id]=value;}
      const values=new Set(ids(remote.productIds));for(const [id,saved] of Object.entries(pending))saved?values.add(id):values.delete(id);
      localStorage.setItem(ownerKey,JSON.stringify({scope,account}));savePending();publish([...values]);ready=true;await flush();
    }catch{scope='';ready=true;note(text.browser);}
  })();
})();
